import { ReactNode, useMemo } from 'react';

import { GridContainer, GridItem, GridItemProps } from '@zooplus/ui-components';

const GridLayoutWrapper = ({ children }: { children: ReactNode }) => {
  const colSpan: GridItemProps['colSpan'] = useMemo(() => {
    return {
      default: 6,
      sm: 12,
      xxl: 10,
    };
  }, []);

  const colStart: GridItemProps['colStart'] = useMemo(() => {
    return {
      default: 1,
      xxl: 2,
    };
  }, []);

  return (
    <GridContainer>
      <GridItem colSpan={colSpan} colStart={colStart}>
        {children}
      </GridItem>
    </GridContainer>
  );
};

export default GridLayoutWrapper;
